import { render, staticRenderFns } from "./EmployerInformation.vue?vue&type=template&id=4f0dc5a7&scoped=true"
import script from "./EmployerInformation.vue?vue&type=script&lang=js"
export * from "./EmployerInformation.vue?vue&type=script&lang=js"
import style0 from "./EmployerInformation.vue?vue&type=style&index=0&id=4f0dc5a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0dc5a7",
  null
  
)

export default component.exports